import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.setSearchCriteria:
            const { fromCountry, toCountry } = action.payload;
            return {
                ...state,
                toCountry,
                fromCountry,
                toLocationName: action.payload.toLocationName,
                fromLocationName: action.payload.fromLocationName,
                adults: action.payload.adults,
                children: action.payload.children
            };
        default:
            return state;
    }
};
export { reducer, getInitialState };
